export { default } from "./PlasmidStaticMap";
